import { ConsultationCard, Consultation } from 'types';

export const isInspection = (
  consultation: Consultation | ConsultationCard | undefined
): boolean => consultation?.consultationType === 'Inspection';
